// extracted by mini-css-extract-plugin
module.exports = {"bar-mobile":"styles_bar-mobile__3V1YF","back":"styles_back__3NFb0"};